/**
 * PDF Link Accessibility
 * Automatically adds aria-labels to links and buttons pointing to PDF files
 * to warn screen reader users about the file type
 */

(function () {
	'use strict';

	/**
	 * Add aria-label to PDF links
	 */
	function addPdfAriaLabels() {
		// Select all links and buttons with href/data attributes ending in .pdf
		const pdfLinks = document.querySelectorAll('a[href$=".pdf" i], a[href$=".PDF" i], button[data-url$=".pdf" i], button[data-url$=".PDF" i]');

		pdfLinks.forEach(element => {
			// Skip if already has aria-label mentioning PDF
			const existingLabel = element.getAttribute('aria-label');
			if (existingLabel && existingLabel.toLowerCase().includes('pdf')) {
				return;
			}

			// Get the visible text content
			const textContent = element.textContent.trim();

			// Create or update aria-label
			if (existingLabel) {
				// Append (PDF) to existing aria-label
				element.setAttribute('aria-label', existingLabel + ' (PDF)');
			} else if (textContent) {
				// Create new aria-label from text content
				element.setAttribute('aria-label', textContent + ' (PDF)');
			} else {
				// Fallback for elements without text (like icon-only links)
				element.setAttribute('aria-label', 'PDF document');
			}
		});
	}

	// Run on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', addPdfAriaLabels);
	} else {
		addPdfAriaLabels();
	}

	// Also run when new content is dynamically added (for AJAX-loaded content)
	// Using MutationObserver to watch for DOM changes
	const observer = new MutationObserver(function (mutations) {
		let shouldRecheck = false;
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes.length > 0) {
				shouldRecheck = true;
			}
		});
		if (shouldRecheck) {
			addPdfAriaLabels();
		}
	});

	// Start observing the document body for changes
	if (document.body) {
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}

})();
